import { FORNECEDORES } from '@/constants'
import { PropostaService } from '@/services'
import { FornecedorHelper, Validations } from '@/utils'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { VBtn, VCard, VCardActions, VCardText, VCardTitle, VDialog, VForm, VIcon, VRow, VSelect, VSpacer } from 'vuetify/lib'
import './ModalCancelamento.scss'

export enum TELA {
	ETAPA_1 = 1,
	ETAPA_2 = 2
}

@Component({})
export class ModalCancelamento extends Vue {
	@Prop({ type: Number, required: true }) propostaId!: number
	currentScreen = TELA.ETAPA_1
	modalState = false
	formState: boolean = false
	isLoading = false

	motivos = [
		'Crédito Reprovado/Aprovado a menor',
		'DPS negada',
		'Vistoria aprovado à menor',
		'Análise Jurídica não aprovada',
		'FGTS: Sem possibilidade de uso',
		'Banco: Melhor taxa no mesmo banco',
		'Banco: Melhor taxa em outros bancos',
		'Problemas nos documentos do imóvel',
		'Vendedor com dívida alta',
		'Desistência pelo cliente na compra e venda do imóvel',
		'Mudança de Modelo de Pagamento',
		'Não gostou do atendimento',
		'Outros'
	]
	motivo: string = ''
	fornecedor: FORNECEDORES | null = null

	get userCompleteName() {
		const { state } = this.$store
		return state.user?.name
	}

	public render() {
		return (
			<VDialog class="fade-in" persistent clipped fixed right temporary width="500" height="573" vModel={this.modalState}>
				<VCard id="app-modal-cancelamento" class="pa-10 justify-center" align="center">
					<VRow class="d-flex">
						<VSpacer />
						<VBtn disabled={this.isLoading} small color="#4D4D4D" icon fab onClick={() => this.close()}>
							<VIcon>mdi-close</VIcon>
						</VBtn>
					</VRow>
					{this.stepsCancelamento()}
				</VCard>
			</VDialog>
		)
	}

	stepsCancelamento() {
		return (
			<div>
				{this.currentScreen === TELA.ETAPA_1 && this.renderMensagem()}
				{this.currentScreen === TELA.ETAPA_2 && this.renderMotivoCancelamento()}
			</div>
		)
	}

	renderMensagem() {
		return (
			<div>
				<VCardTitle class="font-weight-bold">
					Tem certeza que deseja cancelar a proposta: <br /> Nº. {this.propostaId} ?
				</VCardTitle>
				<VCardText>Propostas canceladas sao excluídas da sua fila de trabalho e não podem ser acessadas novamente.</VCardText>
				<VCardActions class="d-flex align-center justify-center">
					<VBtn class="px-5" depressed color="primary" onClick={() => this.setEtapas(TELA.ETAPA_2)}>
						Continuar
					</VBtn>
					<VBtn class="px-10" dark depressed color="primary" outlined onClick={() => this.close()}>
						Voltar
					</VBtn>
				</VCardActions>
			</div>
		)
	}

	renderMotivoCancelamento() {
		return (
			<VForm ref="cancelamento-form" onSubmit={(e: FormDataEvent) => this.cancelarProposta(e)} vModel={this.formState}>
				<VCardText>{this.userCompleteName}, escolha o motivo do cancelamento e o fornecedor que o cliente seguiu. </VCardText>

				<VCardText>
					<VSelect
						rules={[Validations.isRequired]}
						vModel={this.motivo}
						label="Motivo do cancelamento?"
						outlined
						dense
						items={this.motivos}
					/>

					<VSelect
						label="Qual banco seguiu?"
						vModel={this.fornecedor}
						outlined
						dense
						items={FornecedorHelper.Lista.filter((x) => x.value > 0)}
					/>
				</VCardText>

				<VCardActions>
					<VBtn loading={this.isLoading} type="submit" class="mt-5" color="primary" depressed block>
						Cancelar Proposta
					</VBtn>
				</VCardActions>
			</VForm>
		)
	}
	/**
	 * Controla o fluxo de telas
	 * @param tela
	 */
	setEtapas(tela: TELA) {
		this.currentScreen = tela
	}

	/**
	 * Abre o Modal de cancelamento de proposta
	 */
	openModal() {
		this.modalState = true
	}

	close() {
		this.currentScreen = TELA.ETAPA_1
		this.modalState = false
		this.motivo = ''
		this.fornecedor = null
	}

	async cancelarProposta(e: FormDataEvent) {
		e.preventDefault()

		this.isLoading = true
		const form = this.$refs['cancelamento-form'] as FormElement

		if (await form.validate()) {
			await PropostaService.cancelarProposta({
				propostaId: this.propostaId,
				motivo: this.motivo,
				fornecedor: this.fornecedor
			})

			//if(!response.error)
			this.close()
			this.$emit('modal:close')
		}

		this.isLoading = false
	}
}

export default ModalCancelamento
